import { GridCellProps } from '@progress/kendo-react-grid';
import { ActionsEllipsisCell } from 'Components/Grid';
import { useGridState, useModalFormState, useToasts } from 'Context';
import {
  ActionsDropdownConfig,
  ReviewerBoardCertificationDocumentModal,
  ReviewerIdBoardCertificationGridSearchModel,
} from 'Models';
import { Permission } from 'Models/Templates/Permission/Permission';
import { ENDPOINTS } from 'Models/Templates/Routes/Routes';
import React from 'react';
import { buildEndpoint, useApiWorker } from 'Utilities';
import { ReviewerBoardCertificationDocumentDrawerForm } from '.';

export const ReviewerBoardCertificationDocumentActionCell: React.FC<
  GridCellProps
> = ({ dataItem, field = '' }) => {
  const API = useApiWorker();
  const toast = useToasts();
  const { refreshGrid } = useGridState();
  const { toggle, setEntityId } = useModalFormState();

  const value = dataItem[field];

  const editItem = () => {
    setEntityId(value);
    toggle();
  };

  const deleteItem = async () => {
    if (
      window.confirm('Are you sure you want to delete board certification?')
    ) {
      try {
        var deleteResponse = await API.delete(
          buildEndpoint(
            ENDPOINTS.reviewerBoardCertificationDocument.base,
            value
          )
        );
        if (deleteResponse.data.isSuccessStatusCode) {
          toast.success('Board certification has been removed.');
        } else if (deleteResponse.headers['exception'] === undefined) {
          toast.error('Fail removing board certification.');
        } else {
          toast.error(deleteResponse.headers['exception']);
        }
        refreshGrid && refreshGrid();
      } catch {
        toast.error('Fail removing board certification.');
      }
    }
  };

  const actionsConfig: ActionsDropdownConfig = {
    items: [
      {
        name: 'Edit',
        permissions: [Permission.EditBoardCertificationDocument],
        modalConfig: {
          modalId:
            ReviewerBoardCertificationDocumentModal.CertificationDocuments,
          entityId: value,
          modalComponent: (
            <ReviewerBoardCertificationDocumentDrawerForm
              formModel={new ReviewerIdBoardCertificationGridSearchModel(value)}
              endpoint={ENDPOINTS.reviewerBoardCertificationDocument.base}
            />
          ),
        },
      },
      {
        name: 'Delete',
        onClick: deleteItem,
        permissions: [Permission.DeleteBoardCertificationDocument],
      },
    ],
  };

  return (
    <ActionsEllipsisCell actionsConfig={actionsConfig} dataItem={dataItem} />
  );
};
